export const CURRENT_USER_RECEIVED = 'users/CURRENT_USER_RECEIVED';
